import { Validite } from './TypeValidite';

export class TypeDelais {

    public receptCandidatures: string ;

	public envoiInvitation: string;

	public validite: Validite;

	public receptionOffres: string;

	constructor() {
		 		this.validite = new Validite();
 
	}
}
